document.addEventListener('DOMContentLoaded', function () {
  var searchToggle = document.getElementById('SearchToggle');
  var searchBar = document.getElementById('HeaderSearchBar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchBar.hasAttribute('hidden') ? false : true;
      if (isOpen) {
        searchBar.setAttribute('hidden', '');
        searchToggle.setAttribute('aria-expanded', 'false');
      } else {
        searchBar.removeAttribute('hidden');
        searchToggle.setAttribute('aria-expanded', 'true');
        var input = searchBar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  var mainImage = document.getElementById('MainProductImage');
  var thumbs = document.querySelectorAll('.product-main__thumb');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-full-src');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  var toggle = document.getElementById('SidebarToggle');
  var sidebar = document.getElementById('CategorySidebar');
  if (!toggle || !sidebar) return;

  toggle.addEventListener('click', function () {
    var isOpen = sidebar.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });

  document.addEventListener('click', function (e) {
    if (!sidebar.contains(e.target) && !toggle.contains(e.target)) {
      sidebar.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
});
